import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import UserInfoHOC from '#components/HOC/UserInfoHOC'
import Avatar from '#components/a/Avatar'
import AusbildungsnachweisIcon from '#components/svg/icons/NavAusbildungsnachweise'
import StyledText from '#components/a/StyledText'
import {routeHelper} from '#config/routeKeys'

export class NachweisEinreichenBenachrichtigung extends React.Component {
  onClickNotification = () => {
    const {onNotificationClick, nachweisId} = this.props
    onNotificationClick(routeHelper.ausbildungsnachweisDetail(nachweisId))
  }

  render() {
    const {userInfo} = this.props
    const text = i18n.t('notification_text_nachweis_einreichen', [`${userInfo.lastname}, ${userInfo.firstname}`])

    return (
      <div
        role="button"
        tabIndex={0}
        className="notification nachweis_notification"
        onClick={this.onClickNotification}
        onKeyPress={this.onClickNotification}
      >
        <Avatar profileImage={userInfo.profileImage} />
        <StyledText text={text} modifier="notification" />
        <div className="notification__icon notification__icon--right">
          <AusbildungsnachweisIcon />
        </div>
      </div>
    )
  }
}

NachweisEinreichenBenachrichtigung.propTypes = {
  nachweisId: PropTypes.string,
  onNotificationClick: PropTypes.func.isRequired,
  userInfo: PropTypes.shape({
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    profileImage: PropTypes.string,
  }).isRequired,
}
export default UserInfoHOC(NachweisEinreichenBenachrichtigung, ['senderId'])
